import { useMemo, useState } from 'react';
import { highlightLabels2021, highlightVideos2021 } from './data';
import { Footer2021, Header2021, use2021Page } from './shared';

const imageIds = Array.from({ length: 8 }, (_, i) => String(i + 1).padStart(3, '0'));

const Highlight2021 = () => {
  const { lang } = use2021Page('Smart Living Partnership Awards 2021 - Highlights');
  const initialTab = useMemo<'img' | 'video' | 'article'>(() => {
    const raw = new URLSearchParams(window.location.search).get('tab')?.toLowerCase();
    if (raw === 'video' || raw === 'videos') return 'video';
    if (raw === 'article' || raw === 'articles') return 'article';
    return 'img';
  }, []);
  const [tab, setTab] = useState<'img' | 'video' | 'article'>(initialTab);
  const [img, setImg] = useState('001');
  return (
    <>
      <Header2021 lang={lang} currentPath="highlight" />
      <main>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/sponsors.png)', marginTop: '8.1%', marginLeft: '-3px' }}>
          <img src="/2021/images/sponsors.png" style={{ visibility: 'hidden' }} alt="" />
        </div>
        <div id="bg-container" className={`highlight-main-container background-container ${tab === 'video' ? 'highlight-video-tab' : ''}`} style={{ backgroundImage: `url(${tab === 'video' ? '/2021/images/highlight.png' : '/2021/images/portfolio.png'})` }}>
          <img id="bg-img" src={tab === 'video' ? '/2021/images/highlight.png' : '/2021/images/portfolio.png'} style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <h1><b>{highlightLabels2021.title[lang]}</b></h1>
            <div className="highlight-category-container">
              <div>
                <span className="viewImg" style={{ cursor: 'pointer' }} onClick={() => setTab('img')}>{highlightLabels2021.images[lang]}</span>
                {' | '}
                <span className="viewVideo" style={{ cursor: 'pointer' }} onClick={() => setTab('video')}>{highlightLabels2021.video[lang]}</span>
                {' | '}
                <span className="viewArticle" style={{ cursor: 'pointer' }} onClick={() => setTab('article')}>{highlightLabels2021.article[lang]}</span>
              </div>
              <br />
              {tab === 'img' && (
                <div className="modal-container" id="highlight-img-container" style={{ display: 'block', backgroundColor: '#e5fde7' }}>
                  <div className="image-modal"><img id="highlight-img" src={`/2021/images/highlight/${img}.jpg`} alt="" /></div>
                  <a className="prev" onClick={() => setImg(String((Number(img) + 6) % 8 + 1).padStart(3, '0'))}>&#10094;</a>
                  <a className="next" onClick={() => setImg(String(Number(img) % 8 + 1).padStart(3, '0'))}>&#10095;</a>
                  <div className="row">{imageIds.map((n) => <div className="column" key={n}><img src={`/2021/images/highlight/small_${n}.jpg`} className="img-preview" data-imgn={n} onClick={() => setImg(n)} /></div>)}</div>
                </div>
              )}
              {tab === 'video' && (
                <div className="modal-container" id="highlight-video-container">
                  <div className="cards">{highlightVideos2021.map((v) => <div className="card" key={v.id}><div><b>{v.title[lang]}</b></div><div className="video-wrapper"><iframe className="iframe" src={`https://www.youtube.com/embed/${v.id}?rel=0`} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ width: '100%', height: '100%', minHeight: 270 }}></iframe></div></div>)}</div>
                </div>
              )}
              {tab === 'article' && (
                <div className="modal-container" id="highlight-article-container">
                  <a href="https://www.etnet.com.hk/www/tc/news/topic_news_category.php?category=smartlivingawards" target="_blank" rel="noreferrer" style={{ display: 'inline-flex', textDecoration: 'none', color: '#666' }}>
                    <div className="arrow"><div className="triangle-right"></div></div>
                    <div><span style={{ fontSize: 18, fontWeight: 'bold' }}>{lang === 'zh' ? '查看活動相關文章' : 'View campaign articles'}</span></div>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer2021 lang={lang} />
    </>
  );
};

export default Highlight2021;
